<template>
  <div>
    <strong>Message:</strong>
    <div
      v-if="isDetailAnObject"
      :class="$style.statusDetailsTable"
    >
      <TableWithEndlessScroll
        :columns="columns"
        :moreToLoad="false"
        :renderActionColumn="true"
        :tableData="tableData"
      >
        <template
          v-slot:expandedContent="props"
        >
          <div :class="$style.contentContainer">
            <!-- Keep pre content inline to prevent adding indentation to first bracket -->
            <pre
              :class="$style.json"
            >{{ JSON.stringify(props.record, null, 2) }}</pre>
          </div>
        </template>
      </TableWithEndlessScroll>
    </div>
    <p v-else>
      <MarkdownBlock :mdTemplate="detailContents" />
    </p>
  </div>
</template>

<script>

import { MarkdownBlock } from '@jumpcloud/ui-components';
import { get, isString } from 'lodash';
import PolicyStatusMixin from 'client/policies/views/PolicyStatusMixin';
import TableWithEndlessScroll from 'client/components/Tables/TableWithEndlessScroll';

export default {
  name: 'PolicyStatusDetail',

  components: { TableWithEndlessScroll, MarkdownBlock },

  mixins: [PolicyStatusMixin],

  props: {
    policyStatus: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      columns: [
        {
          dataField: 'name',
          name: 'Name',
        },
        {
          dataField: 'state',
          name: 'Status',
        },
      ],
    };
  },

  computed: {
    detailContents() {
      const detail = get(this.policyStatus, 'detail', null);
      if (detail && isString(detail)) {
        if (detail.indexOf(';;') !== -1 || detail.indexOf('@@') !== -1) {
          // https://jumpcloud.atlassian.net/wiki/spaces/ET/pages/1122336800/Policy+Results+Use+of+Delimiters+in+Detail+String
          let markdownDetail = detail.replace(/;{2}/g, '\n\n');
          markdownDetail = markdownDetail.replace(/@{2}/g, '\n- ');
          markdownDetail = `\n${markdownDetail}`;
          return markdownDetail;
        }
        return detail;
      }
      return this.policyStatus.detail || this.policyStatus.stdOut;
    },

    isDetailAnObject() {
      return Object.keys(this.detailObject).length > 0;
    },

    tableData() {
      return Object.values(this.detailObject);
    },
  },
};
</script>

<style scoped module>
.contentContainer {
  border-top: 1px solid gradientLight3;
  margin-top: 4px;
}

.json {
  border: none;
  border-radius: 0;
  font-family: var(--jc-font-monospace);
  font-size: 10px;
}

.statusDetailsTable {
  margin: 10px 0;
}

</style>
